import { siteUrl } from '../site/metadata';
import { buildEnglishIqPath } from './build-english-iq-path';

export function buildEnglishIqWebUrl(locale?: string): string {
  return `${siteUrl}${buildEnglishIqPath(locale)}`;
}
